import Query from "@arcgis/core/rest/support/Query";
import FieldNames from "../defaults/FieldNames.json";
import GeneralService from "./GeneralService";
import StatisticDefinition from "@arcgis/core/rest/support/StatisticDefinition";
import { getAppConfig, getAttributeServiceUrl, getNifcToken, getViewServiceUrl } from "../utils/ReduxHelper";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import axios from "axios";
import FileSaver from 'file-saver';


const TargetAccomplishmentService = {
  // Pow GET queries
  getReducedFinalArray: function(baseGroupBy, initialSet, level, message){
    let emptyInitialSet = [];
    let reducedEmptySetAcres = 0;
    let emptyIndSet = [];
    let nonEmptyInitialSet = [];
    if(baseGroupBy.includes(level)){
      emptyInitialSet = initialSet?.filter(x => !x[level]);
      if(emptyInitialSet?.length > 1){
        reducedEmptySetAcres = emptyInitialSet?.map(x => x[FieldNames.targetFields.acresSum] ? x[FieldNames.targetFields.acresSum] : 0)?.reduce((a, b) => a + b, 0);
        emptyIndSet = [{Class: emptyInitialSet[0][FieldNames.targetFields.class], [level]: message, AcresSum: reducedEmptySetAcres}]
      }
      nonEmptyInitialSet = initialSet.filter(x => x[level]);
    }
    const finalSet = emptyIndSet.concat(nonEmptyInitialSet);
    return finalSet;
  },
  // getAllTargetEntriesWhereClause: function(baseGroupBy, departmentExists, agencyExists, regionExists, unitExists, subUnitExists, tribeExists, year) {
  //   let baseWhereClause = "";
  //
  //   if(!departmentExists){
  //     // We are looking at possible department values, so don't filter department
  //     baseWhereClause = `(OBJECTID IS NOT NULL)`;
  //     baseGroupBy = "Class, FundingDepartment";
  //   }
  //   else if (departmentExists && !agencyExists) {
  //     // We are looking at possible agency values, so don't filter agency
  //     // Filter lower level entries out
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseGroupBy = "Class, FundingAgency";
  //   } else if (departmentExists && agencyExists && !regionExists) {
  //     // We are looking at possible region values, so don't filter region
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`
  //     baseGroupBy = "Class, FundingRegion";
  //   } else if (
  //     departmentExists &&
  //     agencyExists &&
  //     regionExists &&
  //     !unitExists
  //   ) {
  //     // We are looking at possible unit values, so don't filter unit
  //     // Don't filter out subunit/tribal data as they can be set from region level
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
  //     baseGroupBy = "Class, FundingUnit";
  //   } else if (
  //     departmentExists &&
  //     agencyExists &&
  //     regionExists &&
  //     unitExists &&
  //     !subUnitExists &&
  //     !tribeExists
  //   ) {
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
  //     if(agencyExists === FieldNames.agencies.blm){
  //       baseGroupBy = "Class, FundingSubUnit";
  //     } else if(agencyExists === FieldNames.agencies.bia){
  //       baseGroupBy = "Class, FundingTribe";
  //     } else {
  //       baseGroupBy = "Class, FundingUnit";
  //     }
  //   } else if (
  //     departmentExists &&
  //     agencyExists &&
  //     regionExists &&
  //     unitExists &&
  //     subUnitExists &&
  //     !tribeExists
  //   ) {
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingSubUnit = '${subUnitExists}')`;
  //     baseGroupBy = "Class, FundingSubUnit";
  //   } else if (
  //     departmentExists &&
  //     agencyExists &&
  //     regionExists &&
  //     unitExists &&
  //     !subUnitExists &&
  //     tribeExists
  //   ) {
  //     baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
  //     baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
  //     if(tribeExists === "No Tribe"){
  //       baseWhereClause = baseWhereClause + ` AND ((FundingTribe = '') OR (FundingTribe IS NULL))`;
  //     } else {
  //       baseWhereClause = baseWhereClause + ` AND (FundingTribe = '${tribeExists}')`;
  //     }
  //     baseGroupBy = "Class, FundingTribe";
  //   } else {
  //     // No grid values when looking at SubUnit/Tribal level
  //     return new Promise((resolve) => {
  //       resolve([]);
  //     });
  //   }
  //
  //   if(year){
  //     baseWhereClause = baseWhereClause + ` AND ((CompletionFiscalYear IS NULL AND InitiationFiscalYear = ${year}) OR (CompletionFiscalYear IS NOT NULL AND CompletionFiscalYear = ${year}))`;
  //   }
  //
  //   let finalClause = `(${baseWhereClause})`;
  //   return finalClause
  // },
  getAllTargetEntriesPostFire: function (serviceUrl, config, fiscalYear, department, agency,
    region, unit, subUnit, tribe, entityType, isTreatment
  ) {
    try
    {
      let baseWhereClause = "";
      let baseGroupBy = "Class";
      let departmentExists = department && department[FieldNames.targetFields.filterDepartment];
      let agencyExists = agency && agency[FieldNames.targetFields.filterAgency];
      let regionExists = region && region[FieldNames.targetFields.filterRegion];
      let unitExists = unit && unit[FieldNames.targetFields.filterUnit];
      let subUnitExists = subUnit && subUnit[FieldNames.targetFields.filterSubUnit];
      let tribeExists = tribe && tribe[FieldNames.targetFields.filterTribe];
      let year = Number(fiscalYear.FiscalYear);
  
      if(!departmentExists)
      {
        // We are looking at possible department values, so don't filter department
        baseWhereClause = `(OBJECTID IS NOT NULL)`;
        baseGroupBy = "Class, FundingDepartment, EntityType";
      }
      else if (departmentExists && !agencyExists) {
        // We are looking at possible agency values, so don't filter agency
        // Filter lower level entries out
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseGroupBy = "Class, FundingAgency, EntityType";
      } else if (departmentExists && agencyExists && !regionExists) {
        // We are looking at possible region values, so don't filter region
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`
        baseGroupBy = "Class, FundingRegion, EntityType";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        !unitExists
      ) {
        // We are looking at possible unit values, so don't filter unit
        // Don't filter out subunit/tribal data as they can be set from region level
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseGroupBy = "Class, FundingUnit, EntityType";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        !subUnitExists &&
        !tribeExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        if(agencyExists === FieldNames.agencies.blm){
          baseGroupBy = "Class, FundingSubUnit, EntityType";
        } else if(agencyExists === FieldNames.agencies.bia){
          baseGroupBy = "Class, FundingTribe, EntityType";
        } else {
          baseGroupBy = "Class, FundingUnit, EntityType";
        }
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        subUnitExists &&
        !tribeExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingSubUnit = '${subUnitExists}')`;
        baseGroupBy = "Class, FundingSubUnit, EntityType";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        !subUnitExists &&
        tribeExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        if(tribeExists === "No Tribe"){
          baseWhereClause = baseWhereClause + ` AND ((FundingTribe = '') OR (FundingTribe IS NULL))`;
        } else {
          baseWhereClause = baseWhereClause + ` AND (FundingTribe = '${tribeExists}')`;
        }
        baseGroupBy = "Class, FundingTribe, EntityType";
      } else {
        // No grid values when looking at SubUnit/Tribal level
        return new Promise((resolve) => {
          resolve([]);
        });
      }
  
      if(year){
        baseWhereClause = baseWhereClause + ` AND ((CompletionFiscalYear IS NULL AND InitiationFiscalYear = ${year}) OR (CompletionFiscalYear IS NOT NULL AND CompletionFiscalYear = ${year}))`;
      }

      if(entityType){
        baseWhereClause = baseWhereClause + ` AND (EntityType = '${entityType}')`;
      }


      const classTypeEstimated = isTreatment ? FieldNames.classTypes.treatment : FieldNames.classTypes.activity;
      const classTypeActual = isTreatment ? FieldNames.classTypes.actualTreatment : FieldNames.classTypes.actualActivity;
      baseWhereClause = baseWhereClause + 
        ` AND (((Class='${classTypeEstimated}') ` +
        `AND DepartmentApprovalDate IS NOT NULL) OR ` + 
        `((Class='${classTypeActual}') ` +
        `AND CompletionDate IS NOT NULL)) AND (CancelledDate IS NULL AND Status <> '${FieldNames.statuses.cancelled}')`;

      let finalClause = `(${baseWhereClause})`;

      let statDefinition = new StatisticDefinition({
        onStatisticField: FieldNames.targetFields.acres,
        outStatisticFieldName: "AcresSum",
        statisticType: "sum"
      });

      const queryObject =  new Query({
        where: finalClause,
        outFields: "*",
        returnGeometry: false,
        returnDistinctValues: false,
        inSR: 102100,
        spatialRel: 'esriSpatialRelIntersects',
        groupByFieldsForStatistics: [baseGroupBy],
        outStatistics: [statDefinition]
      });

      const url = isTreatment ? `${serviceUrl}/${config.targetTreatmentView[config.env].layerId}` : `${serviceUrl}/${config.targetActivityView[config.env].layerId}`;
      return GeneralService.queryCallDirect(url, queryObject).then((results) => {
        let items = [];
        if (results && results.features && results.features.length > 0) {
          let initialSet = [];
          initialSet = results.features.map((eaItem) => eaItem.attributes);
          //Check for any Null and empty strings
          let finalSet = [];
          
          if(baseGroupBy.includes(FieldNames.targetFields.fundingDepartment)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingDepartment, "No Department");
          } else if(baseGroupBy.includes(FieldNames.targetFields.fundingAgency)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingAgency, "No Agency");
          } else if(baseGroupBy.includes(FieldNames.targetFields.fundingRegion)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingRegion, "No Region");
          } else if(baseGroupBy.includes(FieldNames.targetFields.fundingUnit)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingUnit, "No Unit");
          } else if(baseGroupBy.includes(FieldNames.targetFields.fundingSubUnit)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingSubUnit, "No SubUnit");
          } else if(baseGroupBy.includes(FieldNames.targetFields.fundingTribe)){
            finalSet = this.getReducedFinalArray(baseGroupBy, initialSet, FieldNames.targetFields.fundingTribe, "No Tribe");
          }

          if (finalSet && finalSet.length > 0) {
            items = finalSet.map((item, index) => {
              let name = "";
              if(baseGroupBy.includes(FieldNames.targetFields.fundingDepartment)){
                name = !departmentExists ? item[FieldNames.targetFields.fundingDepartment] : departmentExists;
              } else if(baseGroupBy.includes(FieldNames.targetFields.fundingAgency)){
                name = !agencyExists ? item[FieldNames.targetFields.fundingAgency] : agencyExists;
              } else if(baseGroupBy.includes(FieldNames.targetFields.fundingRegion)){
                name = !regionExists ? item[FieldNames.targetFields.fundingRegion] : regionExists;
              } else if(baseGroupBy.includes(FieldNames.targetFields.fundingUnit)){
                name = !unitExists ? item[FieldNames.targetFields.fundingUnit] : unitExists;
              } else if(baseGroupBy.includes(FieldNames.targetFields.fundingSubUnit)){
                name = !subUnitExists ? item[FieldNames.targetFields.fundingSubUnit] : subUnitExists;
              } else if(baseGroupBy.includes(FieldNames.targetFields.fundingTribe)){
                name = !tribeExists ? item[FieldNames.targetFields.fundingTribe] : tribeExists;
              }

              //read only
              let row = {
                ID: index,
                Name: name,
                EntityType: item[FieldNames.targetFields.entityType],
                Class: item[FieldNames.targetFields.class],
                Acres: item[FieldNames.targetFields.acresSum] ? item[FieldNames.targetFields.acresSum] : 0,
              };

              return row;
            });
          }
        }
        return items;
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getLockedEntries: function (
    fiscalYear,
    department,
    agency,
    region,
    unit,
    subunit,
    tribeFullName,
    entityType
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let baseWhereClause = "";
      let departmentExists =
        department && department[FieldNames.powFields.department];
      let agencyExists = agency && agency[FieldNames.powFields.agency];
      let regionExists = region && region[FieldNames.powFields.region];
      let unitExists = unit && unit[FieldNames.powFields.unit];
      let subUnitExists = subunit && subunit[FieldNames.powFields.subUnit];
      let tribeExists =
        tribeFullName &&
        tribeFullName["TribeFullName"];
        /* The above code is a JavaScript comment block. It is not executing any code, but simply
        providing information or notes within the code for developers to read. The `console.log`
        statement is also commented out and not being executed. */
      let year = Number(fiscalYear.FiscalYear);
  
      if(!departmentExists)
      {
        // We are looking at possible department values, so don't filter department
        baseWhereClause = `(Agency = '' OR Agency IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Region = '' OR Region IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Unit = '' OR Unit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit = '' OR SubUnit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Tribe = '' OR Tribe IS NULL)`;
      }
      else if (departmentExists && !agencyExists) {
        // Filter lower level entries out
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.powFields.department]
            }')`
          : `(Department = '' OR Department IS NULL)`);
        // We are looking at possible agency values, so don't filter agency
        baseWhereClause = baseWhereClause + ` AND (Agency <> '' AND Agency IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Region = '' OR Region IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Unit = '' OR Unit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit = '' OR SubUnit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Tribe = '' OR Tribe IS NULL)`;
      } else if (departmentExists && agencyExists && !regionExists) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.powFields.department]
            }')`
          : `(Department = '' OR Department IS NULL)`);

        baseWhereClause =
        baseWhereClause +
        (agencyExists
           ? ` AND (Agency = '${agency[FieldNames.powFields.agency]}')`
           : ` AND (Agency = '' OR Agency IS NULL)`);

        // We are looking at possible region values, so don't filter region
        baseWhereClause = baseWhereClause + ` AND (Region <> '' AND Region IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Unit = '' OR Unit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit  = '' OR SubUnit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Tribe  = '' OR Tribe IS NULL)`;
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        !unitExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department["Department"]
            }')`
          : `(Department = '' OR Department IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.powFields.agency]}')`
            : ` AND (Agency = '' OR Agency IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.powFields.region]}')`
            : ` AND (Region = '' OR Region IS NULL)`);
        baseWhereClause = baseWhereClause + ` AND (Unit <> '' AND Unit IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (SubUnit  = '' OR SubUnit IS NULL)`;
        baseWhereClause = baseWhereClause + ` AND (Tribe  = '' OR Tribe IS NULL)`;

        // We are looking at possible unit values, so don't filter unit
        // Don't filter out subunit/tribal data as they can be set from region level
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        !subUnitExists &&
        !tribeExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.powFields.department]
            }')`
          : `(Department = '' OR Department IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.powFields.agency]}')`
            : ` AND (Agency = '' OR Agency IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.powFields.region]}')`
            : ` AND (Region = '' OR Region IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (unitExists
            ? ` AND (Unit = '${unit[FieldNames.powFields.unit]}')`
            : ` AND (Unit = '' OR Unit IS NULL)`);
        if(agency[FieldNames.powFields.agency] === FieldNames.agencies.blm){
          baseWhereClause = baseWhereClause + ` AND (SubUnit <> '' AND SubUnit IS NOT NULL)`;
        } else if(agency[FieldNames.powFields.agency] === FieldNames.agencies.bia){
          baseWhereClause = baseWhereClause + ` AND (Tribe <> '' AND Tribe IS NOT NULL)`;
        }
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        subUnitExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.powFields.department]
            }')`
          : `(Department = '' OR Department IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.powFields.agency]}')`
            : ` AND (Agency = '' OR Agency IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.powFields.region]}')`
            : ` AND (Region = '' OR Region IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (unitExists
            ? ` AND (Unit = '${unit[FieldNames.powFields.unit]}')`
            : ` AND (Unit = '' OR Unit IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (subUnitExists
            ? ` AND (SubUnit = '${subunit[FieldNames.powFields.subUnit]}')`
            : ` AND (SubUnit = '' OR SubUnit IS NULL)`);
        
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        tribeExists
      ) {
        baseWhereClause =
        baseWhereClause +
        (departmentExists
          ? `(Department = '${
              department[FieldNames.powFields.department]
            }')`
          : `(Department = '' OR Department IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (agencyExists
            ? ` AND (Agency = '${agency[FieldNames.powFields.agency]}')`
            : ` AND (Agency = '' OR Agency IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (regionExists
            ? ` AND (Region = '${region[FieldNames.powFields.region]}')`
            : ` AND (Region = '' OR Region IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (unitExists
            ? ` AND (Unit = '${unit[FieldNames.powFields.unit]}')`
            : ` AND (Unit = '' OR Unit IS NULL)`);
        baseWhereClause =
          baseWhereClause +
          (tribeExists
            ? ` AND (Tribe = '${tribeFullName["TribeFullName"]}')`
            : ` AND (Tribe = '' OR Tribe IS NULL)`);
        
      } else {
        // No grid values when looking at SubUnit/Tribal level
        return new Promise((resolve) => {
          resolve([]);
        });
      }
  
      let finalClause = "(" + baseWhereClause + ` AND (FiscalYear = ${year}))`;

      const queryObject = new Query({
        where: finalClause,
        outFields: "*",
        returnDistinctValues: true,
        orderByFields: "OBJECTID",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(
          rootServiceUrl + "/" + config.programOfWork[config.env].layerId,
          queryObject
        )
        .then((results) => {
          let items = [];
          if (results && results.features && results.features.length > 0) {
            let initialSet = [];
            initialSet = results.features.map((eaItem) => eaItem.attributes);
            if (initialSet && initialSet.length > 0) {
              items = initialSet.map((item) => {
                let name = "";
                if(!departmentExists){
                  name = !departmentExists ? item[FieldNames.powFields.department] : departmentExists;
                } else if(departmentExists && !agencyExists){
                  name = !agencyExists ? item[FieldNames.powFields.agency] : agencyExists;
                } else if(departmentExists && agencyExists && !regionExists){
                  name = !regionExists ? item[FieldNames.powFields.region] : regionExists;
                } else if(departmentExists && agencyExists && regionExists && !unitExists){
                  name = !unitExists ? item[FieldNames.powFields.unit] : unitExists;
                } else if(item[FieldNames.powFields.agency] === FieldNames.agencies.blm && departmentExists && agencyExists && regionExists && unitExists && !subUnitExists){
                  name = !subUnitExists ? item[FieldNames.powFields.subUnit] : subUnitExists;
                } else if(item[FieldNames.powFields.agency] === FieldNames.agencies.bia && departmentExists && agencyExists && regionExists && unitExists && !tribeExists){
                  name = !tribeExists ? item[FieldNames.powFields.tribe] : tribeExists;
                } else if(item[FieldNames.powFields.agency] === FieldNames.agencies.blm && departmentExists && agencyExists && regionExists && unitExists && subUnitExists){
                  name = !subUnitExists ? item[FieldNames.powFields.subUnit] : subUnitExists;
                } else if(item[FieldNames.powFields.agency] === FieldNames.agencies.bia && departmentExists && agencyExists && regionExists && unitExists && tribeExists){
                  name = !tribeExists ? item[FieldNames.powFields.tribe] : tribeExists;
                }

                item["Name"] = name;
                return item;
              });
            }
          }
          return items;
        });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllLockedEntriesForFY: async function (
    fiscalYear
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const url = `${rootServiceUrl}/${config.programOfWork[config.env].layerId}`;
      let year = Number(fiscalYear.FiscalYear);
      let finalClause = `(FiscalYear = ${year})`;
      let allFinalResults = [];
      const numberToTakeEachTime = 2000;
      let startIndex = 0;
      let hasMoreRecords = true;
      while(hasMoreRecords){
        const queryObject = new Query({
          where: finalClause,
          outFields: "*",
          orderByFields: "OBJECTID",
          start: startIndex,
          num: numberToTakeEachTime,
          returnDistinctValues: true
       });
        let interimResults = await GeneralService.queryCall(url, queryObject);
        if(interimResults?.length > 0){
          allFinalResults.push(interimResults);
          if(interimResults.length === numberToTakeEachTime){
            startIndex += numberToTakeEachTime;
            queryObject.start = startIndex;
          } else {
            hasMoreRecords = false;
          }
        }
        else {
          hasMoreRecords = false;
        }
      }

      const allFinalResultsFlattened = (allFinalResults != null && allFinalResults.length > 0) ? allFinalResults.flat() : [];
      
      let items = [];
      if (allFinalResultsFlattened?.length > 0) {
        let initialSet = [];
        initialSet = allFinalResultsFlattened;
        if (initialSet && initialSet.length > 0) {
          items = initialSet;
        }
      }
      return items;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllTargetEntriesFuels: function (serviceUrl, config, fiscalYear, departmentExists, agencyExists,
    regionExists, unitExists, subUnitExists, tribeExists, entityType, isTreatment
  ) {
    try
    {
      let baseWhereClause = "";
      let baseGroupBy = "Class, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      let year = Number(fiscalYear.FiscalYear);
  
      if(!departmentExists)
      {
        // We are looking at possible department values, so don't filter department
        baseWhereClause = `(FundingDepartment IS NOT NULL)`
        baseWhereClause = baseWhereClause + ` AND (FundingAgency IS NOT NULL)`
        baseWhereClause = baseWhereClause + ` AND (FundingRegion IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit IS NOT NULL)`;
        baseGroupBy = "Class, FundingDepartment, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      }
      else if (departmentExists && !agencyExists) {
        // We are looking at possible agency values, so don't filter agency
        // Filter lower level entries out
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency IS NOT NULL)`
        baseWhereClause = baseWhereClause + ` AND (FundingRegion IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit IS NOT NULL)`;
        baseGroupBy = "Class, FundingAgency, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      } else if (departmentExists && agencyExists && !regionExists) {
        // We are looking at possible region values, so don't filter region
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`
        baseWhereClause = baseWhereClause + ` AND (FundingRegion IS NOT NULL)`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit IS NOT NULL)`;
        baseGroupBy = "Class, FundingRegion, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        !unitExists
      ) {
        // We are looking at possible unit values, so don't filter unit
        // Don't filter out subunit/tribal data as they can be set from region level
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit IS NOT NULL)`;
        baseGroupBy = "Class, FundingUnit, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        !subUnitExists &&
        !tribeExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        if(agencyExists === FieldNames.agencies.blm){
          baseWhereClause = baseWhereClause + ` AND (FundingSubunit IS NOT NULL)`;
          baseGroupBy = "Class, FundingSubUnit, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
        } else if(agencyExists === FieldNames.agencies.bia){
          baseWhereClause = baseWhereClause + ` AND (FundingTribe IS NOT NULL)`;
          baseGroupBy = "Class, FundingTribe, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
        } else {
          baseGroupBy = "Class, FundingUnit, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
        }
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        subUnitExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingSubUnit = '${subUnitExists}')`;
        baseGroupBy = "Class, FundingSubUnit, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      } else if (
        departmentExists &&
        agencyExists &&
        regionExists &&
        unitExists &&
        tribeExists
      ) {
        baseWhereClause = baseWhereClause + `(FundingDepartment = '${departmentExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingAgency = '${agencyExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingRegion = '${regionExists}')`;
        baseWhereClause = baseWhereClause + ` AND (FundingUnit = '${unitExists}')`;
        if(tribeExists === "No Tribe"){
          baseWhereClause = baseWhereClause + ` AND ((FundingTribe = '') OR (FundingTribe IS NULL))`;
        } else {
          baseWhereClause = baseWhereClause + ` AND (FundingTribe = '${tribeExists}')`;
        }
        baseGroupBy = "Class, FundingTribe, FundingSourceProgram, FundingSourceCategory, IsCarryover, CancelledDate, Status";
      } else {
        // No grid values when looking at SubUnit/Tribal level
        return new Promise((resolve) => {
          resolve([]);
        });
      }
  
      if(year){
        baseWhereClause = baseWhereClause + ` AND ((CompletionFiscalYear IS NULL AND InitiationFiscalYear = ${year}) OR (CompletionFiscalYear IS NOT NULL AND CompletionFiscalYear = ${year}))`;
      }

      if(entityType){
        baseWhereClause = baseWhereClause + ` AND (EntityType = '${entityType}')`;
      }

      baseWhereClause = baseWhereClause + 
        ` AND (((Class='${FieldNames.classTypes.treatment}') ` +
        `AND DepartmentApprovalDate IS NOT NULL) OR ` + 
        `((Class='${FieldNames.classTypes.actualTreatment}') ` +
        `AND CompletionDate IS NOT NULL)) AND (CancelledDate IS NULL AND Status <> '${FieldNames.statuses.cancelled}')`;
      let finalClause = `(${baseWhereClause})`;

      let statDefinition = new StatisticDefinition({
        onStatisticField: FieldNames.targetFields.acres,
        outStatisticFieldName: "AcresSum",
        statisticType: "sum"
      });

      const queryObject =  new Query({
        where: finalClause,
        outFields: "*",
        returnGeometry: false,
        returnDistinctValues: false,
        inSR: 102100,
        spatialRel: 'esriSpatialRelIntersects',
        groupByFieldsForStatistics: [baseGroupBy],
        outStatistics: [statDefinition]
      });

      const url = isTreatment ? `${serviceUrl}/${config.targetTreatmentView[config.env].layerId}` : `${serviceUrl}/${config.targetActivityView[config.env].layerId}`;
      return GeneralService.queryCallDirect(url, queryObject).then((results) => {
        let items = [];
        if (results && results.features && results.features.length > 0) {
          let initialSet = [];
          initialSet = results.features.map((eaItem) => eaItem.attributes);
          //Check for any Null and empty strings
          let finalSet = initialSet;
          
          if (finalSet && finalSet.length > 0) {
            items = finalSet.map((item, index) => {
              let name = "";
              if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingDepartment)){
                name = !departmentExists ? item[FieldNames.lockedTargetFields.fundingDepartment] : departmentExists;
              } else if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingAgency)){
                name = !agencyExists ? item[FieldNames.lockedTargetFields.fundingAgency] : agencyExists;
              } else if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingRegion)){
                name = !regionExists ? item[FieldNames.lockedTargetFields.fundingRegion] : regionExists;
              } else if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingUnit)){
                name = !unitExists ? item[FieldNames.lockedTargetFields.fundingUnit] : unitExists;
              } else if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingSubUnit)){
                name = !subUnitExists ? item[FieldNames.lockedTargetFields.fundingSubUnit] : subUnitExists;
              } else if(baseGroupBy.includes(FieldNames.lockedTargetFields.fundingTribe)){
                if(!tribeExists && !item[FieldNames.lockedTargetFields.fundingTribe]){
                  name = "No Tribe";
                } else {
                  name = !tribeExists ? item[FieldNames.lockedTargetFields.fundingTribe] : tribeExists;
                }
              }


              const isEstimated = item[FieldNames.lockedTargetFields.class] === FieldNames.classTypes.activity || item[FieldNames.lockedTargetFields.class] === FieldNames.classTypes.treatment ? true : false;
              const isContributed = item[FieldNames.lockedTargetFields.fundingSourceProgram] === FieldNames.fundingSourcePrograms.contributed ? true : false;
              const isBIL = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.bil ? true : false;
              const isFMReg = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.regular ? true : false;
              const isFMDisaster = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.disaster ? true : false;
              const isCarryover = item[FieldNames.lockedTargetFields.isCarryover] === FieldNames.yesNo.yes ? true : false;
              const allApprovedHFRFilter = isEstimated && !isContributed;
              const allApprovedNonHFRFilter = isEstimated && isContributed;
              const actualHFRFilter = !isEstimated && !isContributed;
              const actualNonHFRFilter = !isEstimated && isContributed;

              //read only
              let row = {
                ID: index,
                Name: name,
                AllApprovedHFRAcres: (allApprovedHFRFilter && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                AllApprovedHFRCarryoverAcres: (allApprovedHFRFilter && isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                AllApprovedHFRNonCarryoverAcres: (allApprovedHFRFilter && !isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                ActualHFRAcres: (actualHFRFilter) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                ActualHFRCarryoverAcres: (actualHFRFilter && isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                ActualHFRNonCarryoverAcres: (actualHFRFilter && !isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                AllApprovedNonHFRAcres: (allApprovedNonHFRFilter) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                ActualNonHFRAcres: (actualNonHFRFilter) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                Acres: item[FieldNames.lockedTargetFields.acresSum] ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                BILAcres: (isBIL && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                FMRegAcres: (isFMReg && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                FMDisasterReliefAcres: (isFMDisaster && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                CarryoverAcres: (!isEstimated && isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
                NonCarryoverAcres: (!isCarryover && item[FieldNames.lockedTargetFields.acresSum]) ? item[FieldNames.lockedTargetFields.acresSum] : 0,
              };
              return row;
            });
          }
        }
        return items;
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllTreatmentsForProgramOfWorkLockByFY: async function (fiscalYear) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getViewServiceUrl();
      let baseWhereClause = `((EntityType = '${FieldNames.internalEntityTypes.fuels}') AND ((Class='${FieldNames.classTypes.treatment}' AND DepartmentApprovalDate IS NOT NULL) OR (Class='${FieldNames.classTypes.actualTreatment}' AND CompletionDate IS NOT NULL)) AND (CancelledDate IS NULL AND Status <> '${FieldNames.statuses.cancelled}'))`;
      let year = Number(fiscalYear.FiscalYear);
  
      if(year){
        baseWhereClause = baseWhereClause + ` AND ((CompletionFiscalYear IS NULL AND InitiationFiscalYear = ${year}) OR (CompletionFiscalYear IS NOT NULL AND CompletionFiscalYear = ${year}))`;
      }

      baseWhereClause = baseWhereClause + `AND ((FundingDepartment IS NOT NULL) AND (FundingAgency IS NOT NULL) AND (FundingRegion IS NOT NULL) AND (FundingUnit IS NOT NULL))`

      let finalClause = `(${baseWhereClause})`;
      const url = `${rootServiceUrl}/${config.targetTreatmentView[config.env].layerId}`;

      let allFinalResults = [];
      const numberToTakeEachTime = 2000;
      let startIndex = 0;
      let hasMoreRecords = true;
      while(hasMoreRecords){
        const queryObject = new Query({
          where: finalClause,
          outFields: "*",
          orderByFields: "JoinID",
          start: startIndex,
          num: numberToTakeEachTime,
          returnDistinctValues: true
       });
        let interimResults = await GeneralService.queryCall(url, queryObject);
        if(interimResults && interimResults.length > 0){
          allFinalResults.push(interimResults);
          if(interimResults.length === numberToTakeEachTime){
            startIndex += numberToTakeEachTime;
            queryObject.start = startIndex;
          } else {
            hasMoreRecords = false;
          }
        }
        else {
          hasMoreRecords = false;
        }
      }

      const allFinalResultsFlattened = (allFinalResults != null && allFinalResults.length > 0) ? allFinalResults.flat() : [];
      
      if(allFinalResultsFlattened?.length > 0)
      {
        let dataSet = [];
        let items = [];

        dataSet = allFinalResultsFlattened;
        if (dataSet?.length > 0) {
          items = dataSet.map((item, index) => {
            const isEstimated = item[FieldNames.lockedTargetFields.class] === FieldNames.classTypes.activity || item[FieldNames.lockedTargetFields.class] === FieldNames.classTypes.treatment ? true : false;
            const isContributed = item[FieldNames.lockedTargetFields.fundingSourceProgram] === FieldNames.fundingSourcePrograms.contributed ? true : false;
            
            const isBIL = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.bil ? true : false;
            const isFMReg = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.regular ? true : false;
            const isFMDisaster = item[FieldNames.lockedTargetFields.fundingSourceCategory] === FieldNames.targetAccomplishmentBuckets.disaster ? true : false;
            const isCarryover = item[FieldNames.lockedTargetFields.isCarryover] === FieldNames.yesNo.yes ? true : false;
            const isDepApproved = item[FieldNames.featureFields.departmentApprovalDate];

            let row = {
              JoinID: item[FieldNames.featureFields.joinID],
              JoinFeature: item[FieldNames.featureFields.joinFeature],
              FundingDepartment: item[FieldNames.featureFields.fundingDepartment],
              FundingAgency: item[FieldNames.featureFields.fundingAgency],
              FundingRegion: item[FieldNames.featureFields.fundingRegion],
              FundingUnit: item[FieldNames.featureFields.fundingUnit],
              FundingSubUnit: item[FieldNames.featureFields.fundingSubUnit],
              FundingTribe: item[FieldNames.featureFields.fundingTribe],
              TargetAcres: (!isCarryover && !isContributed && isEstimated && isDepApproved)  ? item[FieldNames.fundingFields.acres] : 0,
              AllApprovedHFRAcres: (isEstimated && !isContributed && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
              ActualHFRAcres: (!isEstimated && !isContributed) ? item[FieldNames.fundingFields.acres] : 0,
              AllApprovedNonHFRAcres: (isEstimated && isContributed) ? item[FieldNames.fundingFields.acres] : 0,
              ActualNonHFRAcres: (!isEstimated && isContributed) ? item[FieldNames.fundingFields.acres] : 0,
              Acres: item[FieldNames.fundingFields.acres] ? item[FieldNames.fundingFields.acres] : 0,
              BILAcres: (isBIL && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
              FMRegAcres: (isFMReg && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
              FMDisasterReliefAcres: (isFMDisaster && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
              CarryoverAcres: (isCarryover && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
              NonCarryoverAcres: (!isCarryover && item[FieldNames.fundingFields.acres]) ? item[FieldNames.fundingFields.acres] : 0,
          };

            return row;
          });
        }

        return items;
      }
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addProgramOfWorkRecords: async function (
    powRecordsToAdd
  ) {
    try
    {
      if(!powRecordsToAdd?.length > 0)
      {
        return [];
      }
      let allFinalResults = [];
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      let featureUrl = `${rootServiceUrl}/${
        config.programOfWork[config.env].layerId
      }/addFeatures`;

      let adjustedPows = [];
      powRecordsToAdd.forEach((pow) => {
        const newFeature = {
          attributes: pow,
        };
        adjustedPows.push(newFeature);
      });
      const numberToTakeEachTime = 500;
      let startCount = 0;
      let hasMoreRecords = true;
      let finalResults = "";
      while (hasMoreRecords) {
        const numberToTake =
          startCount + numberToTakeEachTime > adjustedPows.length
            ? adjustedPows.length - startCount
            : numberToTakeEachTime;
        let numbersToRun = adjustedPows.slice(
          startCount,
          numberToTake + startCount
        );
        try {
          finalResults = await GeneralService.updateCallForMultiples(
            featureUrl,
            nifcToken,
            numbersToRun
          );
          if (finalResults && finalResults.addResults) {
            allFinalResults.push(finalResults.addResults);
          }
        } catch (e) {
          numbersToRun.forEach((item) => {
            let identifier =
              item[FieldNames.featureFields.objectID] +
              "-" +
              item[FieldNames.powFields.constructedFieldName] +
              "-" +
              item[FieldNames.powFields.subUnit] +
              "-" +
              item[FieldNames.powFields.tribe];
            const newItem = {
              objectId: identifier,
              success: false,
            };
            allFinalResults.push(newItem);
          });
        }
        hasMoreRecords =
          adjustedPows.length > startCount + numberToTakeEachTime;
        startCount += numberToTakeEachTime;
      }
      let failedItems = [];
      let successfulItems = [];
      if (!hasMoreRecords) {
        allFinalResults.flat().forEach((result) => {
          if (result) {
            if (!result.success) {
              failedItems.push(result.objectId);
            } else {
              successfulItems.push(result.objectId);
            }
          }
        });
      }

      const allItemResults = {
        successful: successfulItems,
        failures: failedItems,
      };
      return allItemResults;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateMultiplePows: async function (
    powsForUpdating
  ) {
    try
    {
      if(!powsForUpdating?.length > 0)
      {
        return [];
      }
      let allFinalResults = [];
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();

      let featureUrl = `${rootServiceUrl}/${
        config.programOfWork[config.env].layerId
      }/updateFeatures`;

      let adjustedPows = [];
      powsForUpdating.forEach((pow) => {
        const newFeature = {
          attributes: pow,
        };
        adjustedPows.push(newFeature);
      });
      const numberToTakeEachTime = 500;
      let startCount = 0;
      let hasMoreRecords = true;
      let finalResults = "";
      while (hasMoreRecords) {
        const numberToTake =
          startCount + numberToTakeEachTime > adjustedPows.length
            ? adjustedPows.length - startCount
            : numberToTakeEachTime;
        let numbersToRun = adjustedPows.slice(
          startCount,
          numberToTake + startCount
        );
        try {
          finalResults = await GeneralService.updateCallForMultiples(
            featureUrl,
            nifcToken,
            numbersToRun
          );
          if (finalResults && finalResults.updateResults) {
            allFinalResults.push(finalResults.updateResults);
          }
        } catch (e) {
          numbersToRun.forEach((item) => {
            const newItem = {
              objectId: item.attributes[FieldNames.featureFields.objectID],
              success: false,
            };
            allFinalResults.push(newItem);
          });
        }
        hasMoreRecords =
          adjustedPows.length > startCount + numberToTakeEachTime;
        startCount += numberToTakeEachTime;
      }
      let failedItems = [];
      let successfulItems = [];
      if (!hasMoreRecords) {
        allFinalResults.flat().forEach((result) => {
          if (result) {
            if (!result.success) {
              failedItems.push(result.objectId);
            } else {
              successfulItems.push(result.objectId);
            }
          }
        });
      }

      const allItemResults = {
        successful: successfulItems,
        failures: failedItems,
      };
      return allItemResults;
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  uploadProgramOfWorkCSV: async function (csvString, fileName) {
    try
    {
      if(!csvString || !fileName)
      {
        throw new Error("Missing input parameters");
      }
      const config = getAppConfig();
      const url = `${config.gpServiceCsvUpload[config.env]?.portalItem?.url}`;
      const paramsObj = {
        csv_string: csvString,
        out_filename: fileName
      }
      let uploadResp = await geoprocessor.submitJob(url, paramsObj);
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  downloadProgramOfWorkCSV: async function (fileName) {
    try
    {
      if(!fileName)
      {
        throw new Error("Missing input parameters");
      }
      const config = getAppConfig();
      const filePath =   `/${config.fileBasePath && config.fileBasePath.hasOwnProperty(config.env) ? config.fileBasePath[config.env] + '/files/' : '/files/'}` + fileName + ".csv";
      const resp = await axios.get(filePath, {
        responseType: 'blob',
      })
      const dataBlob = new Blob([resp.data]);
      FileSaver.saveAs(dataBlob, `${fileName}.csv` );
    }
    catch(e)
    {
      throw e;
    }
  },
  checkProgramOfWorkFileExistence: async function (fileName) {
    try
    {
      if(!fileName)
      {
        throw new Error("Missing input parameters");
      }
      const config = getAppConfig();
      const filePath =  `/${config.fileBasePath && config.fileBasePath.hasOwnProperty(config.env) ? config.fileBasePath[config.env] + '/files/' : '/files/'}` + fileName + ".csv";
      const resp = await axios.get(filePath, {
        method: "HEAD"
      })
      return resp;
    }
    catch(e)
    {
      throw e;
    }
  }
};


export default TargetAccomplishmentService;
